import script from "./burger.vue?vue&type=script&setup=true&lang=js"
export * from "./burger.vue?vue&type=script&setup=true&lang=js"

import "./burger.vue?vue&type=style&index=0&id=6916f514&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6916f514"]])

export default __exports__